import React, { useEffect, useMemo, useState } from "react";
import { catchError, of, switchMap, tap, map } from "rxjs";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Publications from "../MainPublications";
import apiClient from "../../../../services/apiClient";
import rxErrorHandler from "../../../../common/helpers/rxErrorHandler";
import SourceEntity from "../../models/SourceEntity";
import {
  getSearchEntity,
  getPublicationCountEntities,
} from "../../../../state/selectors/Publications.selectors";
import Loader from "../../../Loader";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import parseEntity from "./parseEntity";

function PortalPublications(props) {
  const {
    publicationsApiEndpoint: path,
    isLiveAnnotation,
    searchEntity,
    entities,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [relatedPubs, setRelatedPubs] = useState([]);
  const errMsg = "Failed to load publications";
  const symbol = searchEntity?.symbol;

  useEffect(() => {
    of(null)
      .pipe(
        tap(() => setError(null)),
        tap(() => setIsLoading(true)),
        switchMap(() => apiClient.getRelatedPubs({ path })),
        map((res) => res.entities || []),
        map((ents) => ents.map((x) => parseEntity(x))),
        catchError(rxErrorHandler(() => setError(errMsg), [])),
        tap((x) => setRelatedPubs(x)),
        tap(() => setIsLoading(false))
      )
      .subscribe(() => {});
  }, [path]);

  const filteredEntities = useMemo(() => {
    if (!symbol) return entities;
    return entities.filter((x) => x.symbol === symbol);
  }, [entities, symbol]);

  const filteredAnnotations = useMemo(() => {
    if (!symbol) return relatedPubs;
    return relatedPubs.filter((x) => x.symbol === symbol);
  }, [relatedPubs, symbol]);

  if (isLoading) {
    return (
      <div className="tw-h-32">
        <Loader />
      </div>
    );
  }

  if (error) {
    return <div>something went wrong</div>;
  }

  if (!isLiveAnnotation && !relatedPubs?.length) {
    return <div>No data</div>;
  }

  if (isLiveAnnotation) {
    return (
      <Publications
        isClinicalResults={true}
        portalEntities={filteredEntities}
      />
    );
  }

  if (!isLiveAnnotation && relatedPubs.length) {
    return (
      <Publications
        isClinicalResults={true}
        portalEntities={filteredAnnotations}
      />
    );
  }

  return null;
}

PortalPublications.propTypes = {
  searchEntity: PropTypes.instanceOf(SourceEntity).isRequired,
  entities: PropTypes.arrayOf(PropTypes.instanceOf(SourceEntity)),
  publicationsApiEndpoint: PropTypes.string.isRequired,
  isLiveAnnotation: PropTypes.bool.isRequired,
};

PortalPublications.defaultProps = {
  entities: [],
};

const mapStateToProps = (state) => ({
  entities: getPublicationCountEntities(state),
  searchEntity: getSearchEntity(state),
});

export default withErrorGuard(
  React.memo(connect(mapStateToProps)(PortalPublications)),
  "Publications",
  "Publications"
);
